export default __webpack_public_path__ + "static/media/intro-africa.5f7656a9.jpg";